import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const pressRoutes = [
  /**
   * Example: https://www.edmunds.com/press/
   * Example: https://www.edmunds.com/press/index.html
   */
  {
    path: ['/press/', '/press/index.html'],
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "press-landing" */ '../pages/about/press/press-definition')
    ),
    chunkName: 'press-landing',
    resolveLocationInParallelToPagePreload: true,
  },
  /**
   * Example: https://www.edmunds.com/press/press-archive.html
   */
  {
    path: '/press/press-archive.html',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "press-archive-landing" */ '../pages/about/press/press-archive-definition')
    ),
    chunkName: 'press-archive-landing',
    resolveLocationInParallelToPagePreload: true,
  },
  /**
   * Example: https://www.edmunds.com/press/edmunds-u-drags-crowns-corvette-zr1.html
   */
  {
    path: '/press/:articleId.html',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "press-article" */ '../pages/about/press/press-article-definition')
    ),
    chunkName: 'press-article',
    resolveLocationInParallelToPagePreload: true,
  },
];
